import React from 'react';

import { Tooltip } from '@mui/material';
import FilterIcon from '@mui/icons-material/Filter';

import { formatDisplayEmptyValue } from 'components/SampleEditor/helpers/functions';

import { useSampleNameRendererStyles } from 'components/SampleEditor/components/styles';

export const SampleNameRenderer = ({ data, openAssociatedSlides }) => {
  const { name, uuid, associated_slides_count } = data;

  const { classes } = useSampleNameRendererStyles();

  return (
    <span id="no-edit" className={classes.root}>
      <span className={classes.name}>{formatDisplayEmptyValue(name)}</span>
      {!!associated_slides_count && (
        <Tooltip
          title={`View ${associated_slides_count} associated slide${
            associated_slides_count > 1 ? 's' : ''
          }`}
          placement="right"
        >
          <FilterIcon
            className={classes.icon}
            onClick={() =>
              openAssociatedSlides({
                sampleUUID: uuid,
                sampleName: name,
              })
            }
          />
        </Tooltip>
      )}
    </span>
  );
};
